"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Role = function () {
  /*
    bekannte Rollen:
    1:Schüler
    2:Schuel/Schulträger
    3:Sachbearbeiter
    4:Admin
    */

  function Role(name, role) {
    _classCallCheck(this, Role);

    this.Name = name; //Bezeichnung als String
    this.Role = role; // Rollenidx
    Rights = [];
  }

  _createClass(Role, [{
    key: "setRights",
    value: function setRights(rights) {
      var _this = this;

      this.Rights = [];
      rights.forEach(function (e) {
        _this.Rights.push(e);
      });
    }
  }, {
    key: "getRights",
    value: function getRights() {
      return this.Rights;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.Name;
    }
  }, {
    key: "getRole",
    value: function getRole() {
      return this.Role;
    }
  }]);

  return Role;
}();

exports.default = Role;